import { createContext } from 'react';

import newGroupBubble from '../../../utils/audio/newGroupBubble.wav';

import { usePumpFunBubbles } from '../hooks/usePumpFunBubbles';
import { isPumpFunSoundMuted } from '../localStorage';

const newGroupBubbleSound = new Audio(newGroupBubble);

export const PumpFunBubblesContext = createContext<ReturnType<typeof usePumpFunBubbles>>([
    {
        get: () => ({
            bubbles: [],
            loading: null,
        }),
        subscribe: () => () => {},
    },
    () => {},
]);

export const PumpFunBubblesProvider = ({ enabled, children }: React.PropsWithChildren<{ enabled: boolean }>) => {
    const pumpfun = usePumpFunBubbles({
        enabled,
        onNewBubble: () => {
            if (!isPumpFunSoundMuted()) {
                newGroupBubbleSound.play().catch((e) => console.warn('Sound play failed:', e));
            }
        },
    });

    return <PumpFunBubblesContext.Provider value={pumpfun}>{children}</PumpFunBubblesContext.Provider>;
};
